module.exports = __webpack_public_path__ + "static/media/estatistica.c70a8d84.svg";